import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["deleteConfirmationBtn", "cancelDeleteConfirmationBtn", "deleteConfirmationBtn"];
  
  connect() {
    if (document.querySelector('#close_facility_modal')) {
      document.querySelector('#close_facility_modal').addEventListener('click', this.showConfirmationPopUp.bind(this))
    }
    this.timeoutId = null;
    document.body.addEventListener('keydown', this.closeOnEscape.bind(this))
    $('#refund_void_charge_modal').on('hidden.bs.modal', this.closeRefundModal.bind(this));
    $('#void-invoice-modal').on('hidden.bs.modal', this.closePendingVoidModal.bind(this));
    $('#new_facility_modal').on('hidden.bs.modal', this.resetFormFields.bind(this));
  }
  
  showConfirmationPopUp(event){
    event.preventDefault();
    $('#facility_confirmation_modal').modal('show');
    $('#new_facility_modal').modal('hide');
  }
  
  closeMemberModal(){
    $('#facility_confirmation_modal').modal('hide');
    $('#new_facility_modal').modal('hide');
    this.resetFormFields();
  }
  
  closeWarningModal(){
    $('#facility_confirmation_modal').modal('hide');
    setTimeout(() => {
      $('#new_facility_modal').modal('show');
    }, 500);
  }
  
  redirectToMemberPage(){
    window.open(`/organizations/${$('#new_facility_modal').data('organizationName')}/affiliate_members?show_modal=true`, "_blank");
  }

  showDeleteConfirmationPopUp(event){
    event.preventDefault();
    $('#delete_confirmation_modal').modal('show');
  }
  
  closeDeleteConfirmationPopUp(){
    $('#delete_confirmation_modal').modal('hide');
  }

  showModal(event){
    event.preventDefault();
    const element = event.target.matches('button') ? event.target : this.getParentsUntil(event.target, 'button')[0];
    const modalId = element.dataset.modalTarget;
    $(`#${modalId}`).modal('show');
  }

  closeModal(event){
    event.preventDefault();
    const element = event.target.matches('button') ? event.target : this.getParentsUntil(event.target, 'button')[0];
    const modalId = element.dataset.modalTarget;
    $(`#${modalId}`).modal('hide');
  }

  closeEditOverviewModal() {
    $('#edit-affiliate-facility-overview-modal').modal('hide');
  }

  closeEditGeneralModal() {
    $('#edit-affiliate-facility-general-modal').modal('hide');
  }
  
  showVoidInvoiceModal(event) {
    const data = event.target.closest('tr').dataset
    $('#pending-void-modal-header')[0].querySelector('h5').textContent = data.memo;
    $('#pending_due_date').val(data.dueOn.replace(/['"]+/g, '').replaceAll('-', '/'));
    $('#pending_memo').val(data.memo);
    $('#pending_amount_due').val(`$${data.amountDue}0`);
    $('#pending_notes').val(data.notes);
    $('#invoice_id').val(data.invoiceId);
    $('#void-invoice-modal').modal('show');
  }
  
  confirmPendingVoidAction(event) {
    const button = event.target;
    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    let invoiceId = $('#invoice_id').val();
    const modal = event.target.closest('#void-invoice-modal');

    if (button.textContent === 'Confirm?') {
      if (this.timeoutId) {
        const url =  `/organizations/${$('#organization').val()}/invoices/${invoiceId}.json`;
        
        fetch(url, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': token
          },
        })
        .then(response => {
          if (response.ok) {
            this.loadPendingInvoices();
            $(modal).modal('hide');
          }
        });
      }
    } else {      
      button.textContent = 'Confirm?';
      button.classList.remove('btn-warning');
      button.classList.add('btn-danger');

      this.timeoutId = setTimeout(() => {
        button.textContent = 'Void';
        button.classList.remove('btn-danger');
        button.classList.add('btn-warning');
        this.timeoutId = null; 
      }, 3000);
    }
  }

  closePendingVoidModal() {
    $('#void_invoice_btn').text("Void");
    $('#void_invoice_btn').removeClass('btn-danger');
    $('#void_invoice_btn').addClass('btn-warning');
    clearTimeout(this.timeoutId);
    this.timeoutId = null;
  }

  openEditOverviewModal() {
    $('#edit-affiliate-facility-overview-modal').modal('show');
  }

  openEditGeneralModal() {
    $('#edit-affiliate-facility-general-modal').modal('show');
  }

  getParentsUntil(el, selector) {
    let parents = [],
      _el = el.parentNode;
    while (_el && typeof _el.matches === 'function') {
      parents.unshift(_el);
      if (_el.matches(selector)) return parents;
      else _el = _el.parentNode;
    }
    return [];
  };

  resetFormFields() {
    const form = document.querySelector('#new_affiliate_facility');
    form.querySelectorAll('input, textarea, select').forEach((element) => {
      if (element.type !== 'submit') {
        if (element.tagName === 'SELECT') {
          if ($(element).hasClass('select2-hidden-accessible')) {
            $(element).val(null).trigger('change');
          } else {
            element.selectedIndex = 0;
          }
        } else if (element.type === 'checkbox' || element.type === 'radio') {
          element.checked = false;
        } else {
          element.value = '';
        }
      }

      const errorSpan = element.parentElement.querySelector('.help-block.text-danger');
      if (errorSpan) {
        errorSpan.textContent = '';
      }
    });
  }

  scrollPageToTop() {
    const facilityModalScrollable = document.querySelector('#new_facility_modal');
    facilityModalScrollable.scrollTo({ top: 0, behavior: 'smooth' });
  }

  closeOnEscape(event) {
    if (event.keyCode === 27) {
      if (document.querySelector('#new_member_modal') || document.querySelector('#new_facility_modal')) {
        this.closeMemberModal();
      } else if (document.querySelector('#refund_void_charge_modal') && $(document.querySelector('#refund_void_charge_modal')).hasClass('show')) {
        $('#refund_void_charge_modal').modal('hide');
      } else if (document.querySelector('#void-invoice-modal') && $(document.querySelector('#void-invoice-modal')).hasClass('show')) {
        $('#void-invoice-modal').modal('hide');
      }
    }
  }

  openInvoiceModal(e) {
    const element = $('#facility-invoice-modal');
    const frameId = element.data('frameId');
    const frame = element.find(`#${frameId}`);
    frame.attr('src', element.data('targetUrl'));
    element.modal('show');
  }

  closeInvoiceModal() {
    const element = $('#facility-invoice-modal');
    element.modal('hide');
    const frameId = element.data('frameId');
    const frame = element.find(`#${frameId}`);
    frame.src = '';
  }

  showRefundVoidChargeModal(event) {
    const data = event.target.closest('tr').dataset
    $('#void-modal-header')[0].querySelector('h5').textContent = data.memo;
    $('#due_date').val(data.dueOn.replace(/['"]+/g, '').replaceAll('-', '/'));
    $('#memo').val(data.memo);
    $('#amount_due').val(`$${data.amountDue}0`);
    $('#refund_notes').val(data.notes);
    $('#payment_method').val(data.paymentMethod);
    $('#invoice_id').val(data.invoiceId);
    $('#refund_void_charge_modal').modal('show');
    if ($(event.target).closest('tr').find('#paid_invoice_status').text().trim() === "REFUNDED") {
      $('#refund_void_charge_modal').find('#refund_charge_btn').prop('disabled', true);
      $('#refund_void_charge_modal').find('#refund_status').text("Refunded");
    } else {
      $('#refund_void_charge_modal').find('#refund_charge_btn').prop('disabled', false);
      $('#refund_void_charge_modal').find('#refund_status').text("");
    }
  }

  confirmRefundAction(event) {
    const button = event.target;
    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    let invoiceId = $('#invoice_id').val();
    const modal = event.target.closest('#refund_void_charge_modal');

    if (button.textContent === 'Confirm?') {
      if (this.timeoutId) {
        const url = `/organizations/${$('#organization').val()}/facilities/${$('#affiliate_facility_id').val()}/payments/${invoiceId}/refund`;
        
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': token
          },
        })
        .then(response => {
          if (response.ok) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
            button.textContent = 'Refund';
            button.classList.remove('btn-danger');
            button.classList.add('btn-warning');
            $(modal).find('#refund_charge_btn').prop('disabled', true);
            $(modal).find('#refund_status').text("Refunded");

            const trElement = document.querySelector(`tr[data-invoice-id="${invoiceId}"]`);
            $(trElement).find('#paid_invoice_status').text('REFUNDED');
            $(trElement).find('#paid_invoice_status').removeClass('badge-danger');
            $(trElement).find('#paid_invoice_status').addClass('badge-secondary');
          }
        });
      }
    } else {      
      button.textContent = 'Confirm?';
      button.classList.remove('btn-warning');
      button.classList.add('btn-danger');

      this.timeoutId = setTimeout(() => {
        button.textContent = 'Refund';
        button.classList.remove('btn-danger');
        button.classList.add('btn-warning');
        this.timeoutId = null; 
      }, 3000);
    }
  }

  closeRefundModal() {
    this.removeValidationMessage();
  }

  removeValidationMessage() {
    $('#refund_status').text("");
    $('#refund_charge_btn').text("Refund");
    $('#refund_charge_btn').prop('disabled', false);
    $('#refund_charge_btn').removeClass('btn-secondary');
    $('#refund_charge_btn').removeClass('btn-danger');
    $('#refund_charge_btn').addClass('btn-warning');
    $('#void_charge_btn').text("Void");
    $('#void_charge_btn').removeClass('btn-danger');
    $('#void_charge_btn').addClass('btn-warning');
    clearTimeout(this.timeoutId);
    this.timeoutId = null;
    const validationMessage = document.getElementById('validation-message');
    if (validationMessage) {
      validationMessage.remove();
    }
  }

  confirmVoidAction(event) {
    const button = event.target;

    if (button.textContent === 'Confirm Void?') {
      this.performVoidAction(button);
    } else {
      button.textContent = 'Confirm Void?';
      button.classList.remove('btn-warning');
      button.classList.add('btn-danger');

      this.timeoutId = setTimeout(() => {
        button.textContent = 'Void';
        button.classList.remove('btn-danger');
        button.classList.add('btn-warning');
        this.timeoutId = null;
      }, 2500);
    }
  }

  showValidationMessage(button, message) {
    let validationMessage = document.getElementById('validation-message');
    if (!validationMessage) {
      validationMessage = document.createElement('div');
      validationMessage.id = 'validation-message';
      validationMessage.classList.add('w-100', 'text-center', 'mb-3');
      validationMessage.style.color = 'red';
      validationMessage.style.marginRight = '10px';
      validationMessage.textContent = message;
      $('.modal-footer').before(validationMessage);
    }
  }

  performVoidAction(button) {
    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    const url = `/organizations/${$('#organization').val()}/invoices/${$('#invoice_id').val()}.json`;
    fetch(url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': token
      },
    })
    .then(response => {
      if (response.ok) {
        $(`[data-invoice-id=${$('#invoice_id').val()}]`).remove();
        $('#refund_void_charge_modal').modal('hide');
      } else {
        this.showValidationMessage(button, "Cannot void an invoice with processed charges. Refund charges before voiding invoice.");
        $('#void_charge_btn').text("Void");
        $('#void_charge_btn').removeClass('btn-danger');
        $('#void_charge_btn').addClass('btn-warning');
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
    });
  }
  
  loadPendingInvoices(){
    const frame = $('#pending_invoices');
    frame.attr("src", $(frame)[0].src);
  }
}
